module.exports = __webpack_public_path__ + "img/emoji-neutral-off.f89fe058.svg";